import React, { useState } from 'react'
import { Box, Button, Divider, Stack, TextField, Typography, Alert } from '@mui/material'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import { useNavigate } from 'react-router-dom'
import logoSplash from '../assets/logoSplash.png'
import { useAuth } from '../context/authcontext'

const LoginView = () => {
  const { qrlogin } = useAuth()
  const [username, setUsername] = useState('')
  const [error, setError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  const handleLogin = (event) => {
    if (event) event.preventDefault()
    if (!username.trim() || isSubmitting) return
    setError(null)
    setIsSubmitting(true)
    qrlogin(
      username,
      () => navigate('/mode'),
      (message) => {
        setIsSubmitting(false)
        // L'API ne renvoie pas toujours de message : on garde un repli
        // explicite plutôt qu'un échec silencieux.
        setError(message || "L'authentification a échoué")
      }
    )
  }

  return (
    <Box
      sx={{
        minHeight: 'var(--app-vh)',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        // Le clavier virtuel réduit le viewport : le contenu doit pouvoir
        // défiler plutôt que d'être écrasé ou de passer sous le clavier.
        overflowY: 'auto',
        pt: 'calc(var(--safe-top) + 24px)',
        pb: 'calc(var(--safe-bottom) + 24px)',
        pl: 'calc(var(--safe-left) + 24px)',
        pr: 'calc(var(--safe-right) + 24px)',
      }}
    >
      <Stack
        component="form"
        onSubmit={handleLogin}
        spacing={3}
        sx={{ width: '100%', maxWidth: 420, mx: 'auto', my: 'auto', py: 4 }}
      >
        <Stack alignItems="center" spacing={1.5}>
          <Box
            component="img"
            src={logoSplash}
            alt="TicketNGo"
            sx={{ width: 'clamp(180px, 60vw, 240px)', height: 'auto' }}
          />
          <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
            Contrôle d'accès et scan de billets
          </Typography>
        </Stack>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Clé de connexion"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            error={Boolean(error)}
            autoComplete="off"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            inputProps={{ enterKeyHint: 'go' }}
          />

          {error ? (
            <Alert severity="error" variant="outlined">
              {error}
            </Alert>
          ) : null}

          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            disabled={!username.trim() || isSubmitting}
          >
            {isSubmitting ? 'Connexion…' : 'Connexion'}
          </Button>
        </Stack>

        <Divider sx={{ '&::before, &::after': { borderColor: 'divider' } }}>
          <Typography variant="caption" sx={{ color: 'text.secondary', px: 1 }}>
            OU
          </Typography>
        </Divider>

        <Button
          variant="outlined"
          size="large"
          fullWidth
          color="inherit"
          startIcon={<QrCodeScannerIcon />}
          onClick={() => navigate('/qrlogin')}
        >
          Connexion avec code QR
        </Button>
      </Stack>
    </Box>
  )
}

export default LoginView
